<template>
  <div class="mb-5">
    <a-toolbar
      class="primary-gradient pl-4"
    >
      <v-icon left dark> mdi-label-variant </v-icon
      ><span :class="isDashboard ? 'widget-title' : ''">{{ $t("dashboard.lblNewsUpdates") }}</span>
      <v-spacer></v-spacer>
    </a-toolbar>

    <!--  <v-row>
      <v-col cols="12" sm="12" md="12" style="border: 1px solid lightgray"> -->
    <v-card class="card" color="Neutral" flat :class="isDashboard ? 'news-list-card overflow-y-auto' : ''">
      <v-list color="primaryLight1" flat tile style="padding: 0px" v-if="newsHeader">
        <v-list-item>
          <v-list-item-avatar tile height="50" width="80">
            <v-img contain :src="newsHeader.CompanyLogoURL"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title
              ><h2>{{ newsHeader.CompanyName }}</h2></v-list-item-title
            >
            <v-list-item-subtitle>
              <a
                style="
                  text-decoration: none;
                  color: var(--v-pageHeader-darken1);
                "
                :href="newsHeader.CompanyNewsURL"
                target="_blank"
                :title="newsHeader.CompanyNewsURL"
              >
                <strong>News Source:</strong> {{ newsHeader.CompanyNewsURL }}
              </a></v-list-item-subtitle
            >
          </v-list-item-content>
          <v-list-item-action> </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-card-text>
        <v-skeleton-loader
          v-if="isSkeleton"
          type="article, list-item-three-line"
          class="mb-3"
        ></v-skeleton-loader>
        <v-skeleton-loader
          v-if="isSkeleton"
          type="article, list-item-three-line"
        ></v-skeleton-loader>
        <v-data-iterator
          v-else
          :items="newsList"
          :page.sync="page"
          :items-per-page="5"
          :loading="isloading"
          :loading-text="loadtext"
          :footer-props="{
            'items-per-page-text': $t('lblRowsPerPage'),
          }"
        >
          <template v-slot:default="props">
            <v-row>
              <v-col
                v-for="item in props.items"
                :key="item.id"
                cols="12"
                sm="12"
                md="12"
                lg="12"
                class="pa-0"
              >
                <news-card :news="item"></news-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </v-card-text>
    </v-card>
    <!-- </v-col>
    </v-row> -->
  </div>
</template>

<script>
import NewsCard from "./NewsCard.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import AToolbar from "../../wrapper-component/AToolbar.vue";
export default {
  name: "NewsList",
  props: {
    companyId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      page: 1,
      isloading: false,
      isSkeleton: true,
      isDashboard: false,
    };
  },
  components: {
    NewsCard,
    AToolbar
  },
  mounted() {
    if(this.$route.path == "/dashboard") {
      this.isDashboard = true;
      setTimeout(() => {
        const childCard = document.getElementsByClassName('news-list-card');
        if(childCard.length > 0) {
          const height = childCard[0].parentElement.parentElement.offsetHeight;
          if(height) {
            childCard[0].style.height = `${height - 48}px`;
          }
        }
      },500)
    }  
  },
  async created() {
    const companyNewsData = this.companyId;
    if (companyNewsData) {
      try {
        await this.getNewsListApi(companyNewsData);
      } catch (error) {
        console.error('getNewsListApi', error);
      }
      try {
        await this.getNewsSettingApi(companyNewsData);
      } catch (error) {
        console.error('getNewsSettingApi',error);
      }
      
    }
    this.isSkeleton = false;
  },
 
  computed: {
    ...mapState({
      newsListData: (state) => state.news.newsList,
      newsHeader: (state) => state.news.newsSetting,
    }),
    ...gettersMap(),
    showPastMeetings() {
      return this.$store.state.isShowPastMeetings;
    },
    newsList() {
      if(this.newsListData){
        const data = this.newsListData;

        data.slice().sort(function (a, b) {
          return new Date(b.CreatedDate) - new Date(a.CreatedDate);
        });

        return data;
      }else{
        return []
      }
      
    },
    loadtext() {
      this.isloading = true;
      return this.newsList.length > 0
        ? this.$t("LoaderText")
        : this.$t("noData");
    },
  },
  methods: {
    ...mapActions({
      getNewsListApi: "news/getNewsListByCompanyId",
      getNewsSettingApi: "news/getNewsSettingByCompanyId",
    }),
    toggleShowPastMeeting() {
      this.$store.commit("StoreIsShowPastMeetings", !this.showPastMeetings);
    },
  },
};
function gettersMap() {
  return mapGetters({
    categoriesList: "tenant/agendaCategories",
    meetingTypesList: "tenant/agendaMeetingTypes",
  });
}
</script>
<style scoped>
.card {
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12) !important;
}
</style>